import { IconComponentType } from '../../Icon.types'

const icon: IconComponentType = ({ size = 24, color = 'white', className = '', ariaLabel }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 21 20"
		fill={'none'}
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
		className={className}
	>
		<path
			d="M10.5001 1.66669C5.90508 1.66669 2.16675 5.40502 2.16675 10C2.16675 14.595 5.90508 18.3334 10.5001 18.3334C15.0951 18.3334 18.8334 14.595 18.8334 10C18.8334 5.40502 15.0951 1.66669 10.5001 1.66669ZM10.5001 16.6667C6.82425 16.6667 3.83341 13.6759 3.83341 10C3.83341 6.32419 6.82425 3.33335 10.5001 3.33335C14.1759 3.33335 17.1667 6.32419 17.1667 10C17.1667 13.6759 14.1759 16.6667 10.5001 16.6667Z"
			fill={color}
		/>
		<path
			d="M8.00008 14.1667L14.6667 10L8.00008 5.83335V14.1667Z"
			fill={color}
		/>
	</svg>
)

export default icon
